/**
 * Canonical URL shapes for `/admin-users-management`:
 * - `?tab=users` — liste utilisateurs (default sans query)
 * - `?tab=reference&view=roles|permissions` — catalogue vs matrice
 * - `?tab=assignments&view=users|geo` — affectations vs vue géographique
 *
 * Legacy `?tab=roles|permissions|geographic` est réécrite en canonique via `redirect`.
 */

export const ADMIN_MAIN_TABS = ['users', 'reference', 'assignments'];

const LEGACY_TAB_MAP = {
  roles: { tab: 'reference', view: 'roles' },
  permissions: { tab: 'reference', view: 'permissions' },
  geographic: { tab: 'assignments', view: 'geo' },
};

export function resolveAdminIdentityState(searchParams) {
  const rawTab = searchParams.get('tab') || '';
  const rawView = searchParams.get('view') || '';

  if (LEGACY_TAB_MAP[rawTab]) {
    return {
      mainTab: LEGACY_TAB_MAP[rawTab].tab,
      identityView:
        LEGACY_TAB_MAP[rawTab].tab === 'reference'
          ? LEGACY_TAB_MAP[rawTab].view === 'permissions'
            ? 'permissions'
            : 'roles'
          : LEGACY_TAB_MAP[rawTab].view === 'geo'
            ? 'geo'
            : 'users',
      redirect: LEGACY_TAB_MAP[rawTab],
    };
  }

  const mainTab = ADMIN_MAIN_TABS.includes(rawTab) ? rawTab : 'users';

  if (mainTab === 'users') {
    return { mainTab: 'users', identityView: null, redirect: null };
  }

  if (mainTab === 'reference') {
    const view = rawView === 'permissions' ? 'permissions' : 'roles';
    if (!rawView) {
      return { mainTab: 'reference', identityView: view, redirect: { tab: 'reference', view } };
    }
    return { mainTab: 'reference', identityView: view, redirect: null };
  }

  if (mainTab === 'assignments') {
    const view = rawView === 'geo' ? 'geo' : 'users';
    if (!rawView) {
      return { mainTab: 'assignments', identityView: view, redirect: { tab: 'assignments', view } };
    }
    return { mainTab: 'assignments', identityView: view, redirect: null };
  }

  return { mainTab: 'users', identityView: null, redirect: null };
}
